import { render } from "./ClientSmall.vue?vue&type=template&id=873c1344&scoped=true"
import script from "./ClientSmall.vue?vue&type=script&lang=js"
export * from "./ClientSmall.vue?vue&type=script&lang=js"

import "./ClientSmall.vue?vue&type=style&index=0&id=873c1344&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873c1344"]])

export default __exports__